/*
 * SK — Minuteur de livraison (pages produit)
 * Remplace l'affichage du minuteur de la section sk-product-main :
 *  - compte à rebours de 2 heures (démarre à 02:00:00)
 *  - texte : « 🚚 Commandé avant HH:MM:SS · Livraison 48h »
 *  - emoji inline (juste avant « Commandé ») + contenu centré sur mobile
 * Le temps restant est conservé dans le sessionStorage : il se poursuit d'une
 * page produit à l'autre pendant la visite, et repart à 2h une fois écoulé
 * (ou au début d'une nouvelle session).
 */
(function () {
  var WINDOW_MS = 2 * 60 * 60 * 1000; // 2 heures
  var STORAGE_KEY = 'sk_delivery_deadline';

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function injectStyle() {
    if (document.getElementById('sk-delivery-timer-style')) return;
    var st = document.createElement('style');
    st.id = 'sk-delivery-timer-style';
    st.textContent =
      '@media (max-width: 768px){' +
      '.sk-product-main__delivery-timer{justify-content:center;text-align:center;}' +
      '}';
    document.head.appendChild(st);
  }

  function getDeadline() {
    var now = Date.now();
    var stored = null;
    try { stored = parseInt(sessionStorage.getItem(STORAGE_KEY), 10); } catch (e) {}
    if (!stored || isNaN(stored) || stored <= now) {
      stored = now + WINDOW_MS;
      try { sessionStorage.setItem(STORAGE_KEY, String(stored)); } catch (e) {}
    }
    return stored;
  }

  function initSkDeliveryTimer() {
    var timers = document.querySelectorAll('.sk-product-main__delivery-timer');
    if (!timers.length) return;

    injectStyle();

    timers.forEach(function (timerEl) {
      if (timerEl.dataset.skDeliveryOverride === '1') return;
      timerEl.dataset.skDeliveryOverride = '1';

      // Assure la visibilité (la section ajoute cette classe via son propre JS)
      timerEl.classList.add('sk-product-main__delivery-timer--visible');

      // Reconstruit le contenu : emoji inline dans le même flux que le texte,
      // pour qu'il reste juste avant « Commandé » sur la même ligne.
      timerEl.innerHTML =
        '<span><span class="sk-product-main__timer-icon">🚚</span> Commandé avant <strong class="sk-delivery-countdown">--:--:--</strong>&nbsp;· Livraison 48h</span>';

      var out = timerEl.querySelector('.sk-delivery-countdown');
      if (!out) return;

      function tick() {
        var remaining = Math.max(0, Math.floor((getDeadline() - Date.now()) / 1000));
        var h = Math.floor(remaining / 3600);
        var m = Math.floor((remaining % 3600) / 60);
        var s = remaining % 60;
        out.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSkDeliveryTimer);
  } else {
    initSkDeliveryTimer();
  }
})();
